export default __webpack_public_path__ + "static/media/newConversation.f9f5818f.mp3";